import { useState } from 'react';
import { useParams } from 'react-router-dom';
import cookie from 'js-cookie';

import { useOnMount } from '@app/hooks/lifecycle';
import { APP_LANGUAGES } from '@config/common.config';

import { convertToUrlLocale, getIntlValidLocale } from '../../helpers/locale';
import LanguageSuggestPopupBase from './LanguageSuggestPopup';

const LanguageSuggestPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [preferredLanguage, setPreferredLanguage] = useState('');
  const { language } = useParams<{ language?: string }>();
  const currentLanguage = language && getIntlValidLocale(language);

  useOnMount(() => {
    setIsVisible(!cookie.get(LANGUAGE_PREFERENCE_COOKIE));
    setPreferredLanguage(
      convertToUrlLocale(window.navigator.language.split('-')[0]),
    );
  });

  if (
    !isVisible ||
    (preferredLanguage && !APP_LANGUAGES.includes(preferredLanguage)) ||
    currentLanguage === preferredLanguage
  ) {
    return null;
  }

  return (
    <LanguageSuggestPopupBase
      preferredLanguage={preferredLanguage}
      onClose={() =>
        cookie.set(LANGUAGE_PREFERENCE_COOKIE, String(Number(new Date())))
      }
    />
  );
};

const LANGUAGE_PREFERENCE_COOKIE = 'lang_pref';

export default LanguageSuggestPopup;
